import { FC, ReactNode } from "react";
import { Flex, Heading } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
  heading: string;
}

export const FaqGrouping: FC<Props> = ({ children, heading }) => (
  <Flex
    align="flex-start"
    direction="column"
    maxW="71rem"
    mb={{ base: 8, md: 10 }}
    w="100%"
  >
    <Heading fontWeight="light" mb={{ base: 6, md: 8 }} size="xl">
      {heading}
    </Heading>
    <Flex
      bg="on-accent"
      boxShadow="lg"
      direction="column"
      w="100%"
      px={{ base: 8, md: 24 }}
      py={4}
      rounded="lg"
    >
      {children}
    </Flex>
  </Flex>
);
